module.exports = __webpack_public_path__ + "media/bootstrap-icons/bar-chart-line-5373839e.svg";